/* PlatformsEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("../CommonEditor");
const getDefaultCreateValue = require("./mapDataUtil");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const InputTextControl = uiCore.Control.Textfield.InputText;

class PlatformsEditor extends CommonEditor {
    constructor(args) {
        super(args);
        if (!this._itemData.regex) {
            this.rootElement.classList.add("select");
        }
    }

    _init() {
        if (!this._itemData.regex) {
            const gluPlatforms = _.get(this._itemData, "allGluPlatforms", []);
            const gluVendor = _.get(this._itemData, "vendor", "ALL");
            const opts = this.getDropdownOpts(gluVendor, gluPlatforms);
            this.input.setOptions(opts);
        }

        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        if (item.regex) {
            item.pfRegex = state;
        } else {
            item.pfValue = state;
            item.netBoxName = getDefaultCreateValue(item.vendor, item.pfValue, item.vendorOptions);
        }
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        // console.log(this._itemData);
        if (this._itemData.regex) {
            return new InputTextControl({
                darkTheme: true,
            });
        } else {
            return new SingleComboBoxControl({
                showFilter: true,
                darkTheme: true,
                adjustWidth: true,
                allowClear: false,
            });
        }
    }

    show() {}
    hide() {}

    getDropdownOpts(vendor = "ALL", gluPlatforms) {
        const platforms = gluPlatforms[vendor] || {};
        return platforms.map((platform) => {
            return {
                label: platform,
                value: platform,
            };
        });
    }
}

module.exports = PlatformsEditor;
